<template>
    <ValidationProvider
        :name="name"
        :rules="rules"
        :class="classWrapper"
        tag="div"
    >
        <div class="range-container">
            <input
                @input="onInput"
                :value="value"
                :id="name"
                type="range"
                :min="minValue"
                :max="maxValue"
                :step="step"
                class="form-control-range"
            />
            <div class="range-container__text">{{ value }}px</div>
        </div>
    </ValidationProvider>
</template>

<script>
export default {
    name: 'RangeField',
    props: {
        label: String,
        value: {
            type: [Number, String],
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        rules: {
            type: [String, Array, Object],
        },
        classWrapper: {
            type: String,
        },
        minValue: {
            type: Number,
            required: false,
            default: 0,
        },
        maxValue: {
            type: Number,
            required: false,
            default: 100,
        },
        step: {
            type: Number,
            required: false,
            default: 1,
        },
    },
    methods: {
        onInput(event) {
            this.$emit('input', event.target.value);
        },
    },
};
</script>

<style lang="scss">
.range-container {
    display: flex;
    align-items: center;

    &__text {
        width: 50px;
        text-align: right;
    }
}
</style>
